<template>
    <tr>
        <td class="capacity__cell">
            <router-link v-if="hasPermission('admin')" :to="channelLink">
                {{ row.time_based_ad_format.name }} - {{ row.time_based_ad_location.name }}
            </router-link>

            <span v-else>
                {{ row.time_based_ad_format.name }} - {{ row.time_based_ad_location.name }}
            </span>
        </td>

        <time-capacity-cell v-for="(cell, index) in cells" :key="index" :cell="cell"></time-capacity-cell>
    </tr>
</template>

<script>
    import moment from 'moment'
    import Permissions from '@/mixins/Permissions'
    import TimeCapacityCell from '@/components/Panels/Publications/TimeBasedChannelCapacityPanel/TimeCapacityCell'

    export default {
        components: {TimeCapacityCell},

        mixins: [Permissions],

        props: ['date', 'row'],

        computed: {
            channelLink() {
                return '/portals/' + this.row.time_based_ad_format.time_based_subchannel.time_based_channel.portal_id + '/time-based-channels/' + this.row.time_based_ad_format.time_based_channel_id
            },

            end() {
                return moment(this.date).add(27, 'days').format('YYYY-MM-DD')
            },

            cells() {
                return this.intervals
                    .map(interval => {
                        return {
                            colspan: interval.ends_at.diff(interval.starts_at, 'days'),
                            ad: interval.ad
                        }
                    })
                    .filter(cell => {
                        return cell.colspan > 0
                    })
            },

            intervals() {
                let intervals = this.cappedAds
                    .reduce((intervals, ad) => {
                        intervals[intervals.length - 1].ends_at = moment(ad.starts_at)

                        intervals.push({
                            starts_at: moment(ad.starts_at),
                            ends_at: moment(ad.ends_at).add(1, 'days'),
                            ad
                        })

                        intervals.push({starts_at: moment(ad.ends_at).add(1, 'days'), ad: null})

                        return intervals
                    }, [{starts_at: moment(this.date), ad: null}])

                intervals[intervals.length - 1].ends_at = moment(this.end).add(1, 'days')

                return intervals
            },

            cappedAds() {
                return this.row.ads
                    .map(ad => {
                        if (moment(ad.starts_at) < moment(this.date)) {
                            ad.starts_at = this.date
                        }

                        if (moment(ad.ends_at) > moment(this.end)) {
                            ad.ends_at = this.end
                        }

                        return ad
                    })
            }
        }
    }
</script>
